import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const workspaceInit = {
  selectedGroup: '',
  directedFromDashView: false,
  selectedDashs: [],
  isRecentsOpen: false,
  trashDashboardRedirect: false,
};

function workspaceReducer(draft, { type, payload }) {
  switch (type) {
    case "setSelectedGroup": {
      draft.selectedGroup = payload;
      break;
    }
    case "setSelectedDashs": {
      draft.selectedDashs = payload;
      break;
    }
    case "setIsRecentsOpen": {
      draft.isRecentsOpen = payload;
      break;
    }
    case "setDirectedFromDashView": {
      draft.directedFromDashView = payload;
      break;
    }
    case "setTrashDashboardRedirect": {
      draft.trashDashboardRedirect = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

export const WorkspaceContext = createContext(null);
export const WorkspaceDispatchContext = createContext(null);

export default function WorkspaceProvider({ children }) {
  const [store, dispatch] = useImmerReducer(workspaceReducer, workspaceInit);

  return (
    <WorkspaceContext.Provider value={store}>
      <WorkspaceDispatchContext.Provider value={dispatch}>
        {children}
      </WorkspaceDispatchContext.Provider>
    </WorkspaceContext.Provider>
  );
}

export function useWorkspaceStore() {
  return useContext(WorkspaceContext);
}

export function useWorkspaceDispatch() {
  return useContext(WorkspaceDispatchContext); 
}
